import {CustomFieldProfile, CustomFieldProfileEntity} from "../../../model/custom-field-profile";
import {makeEntitySelectors} from "../base-entity-store";

export interface CustomFieldProfileSelectorProps {

}

const customFieldProfileSelectors = makeEntitySelectors<
  CustomFieldProfile,
  CustomFieldProfileEntity,
  CustomFieldProfileSelectorProps
>({
  defaultProps: {},

  filter: (_v, _props) => true,

  transform: (value) => CustomFieldProfileEntity.from(value),
});

export const customFieldProfilesSelector =
  (props?: CustomFieldProfileSelectorProps) =>
    customFieldProfileSelectors.listSelector(props);

export const customFieldProfileSelector =
  () => customFieldProfileSelectors.singleSelector();
